export interface ModelPolygons
{
  polygons: number;
  triangles: number;
}

export const MODEL_POLYGONS: Record<string, ModelPolygons> = {
  "barriers/bearing.fbx": { polygons: 63, triangles: 124 },
  "barriers/blade.fbx": { polygons: 97, triangles: 192 },
  "barriers/hammer.fbx": { polygons: 140, triangles: 280 },
  "barriers/pillar.fbx": { polygons: 8, triangles: 8 },
  "blocks/block_1x1.fbx": { polygons: 54, triangles: 108 },
  "blocks/block_1x2.fbx": { polygons: 54, triangles: 108 },
  "blocks/block_1x3.fbx": { polygons: 54, triangles: 108 },
  "blocks/block_1x4.fbx": { polygons: 54, triangles: 108 },
  "blocks/block_1x5.fbx": { polygons: 54, triangles: 108 },
  "blocks/block_2x2.fbx": { polygons: 78, triangles: 156 },
  "blocks/canned_block_cube_1x1.fbx": { polygons: 94, triangles: 188 },
  "blocks/canned_block_cube_1x2.fbx": { polygons: 254, triangles: 484 },
  "blocks/canned_block_cube_1x3.fbx": { polygons: 414, triangles: 780 },
  "blocks/cone.fbx": { polygons: 164, triangles: 356 },
  "blocks/cone_crown.fbx": { polygons: 560, triangles: 1130 },
  "blocks/cylinder_colored_1x1.fbx": { polygons: 164, triangles: 356 },
  "blocks/cylinder_colored_1x2.fbx": { polygons: 458, triangles: 932 },
  "blocks/cylinder_colored_1x3.fbx": { polygons: 476, triangles: 968 },
  "blocks/cylinder_grey_1x1.fbx": { polygons: 262, triangles: 524 },
  "blocks/cylinder_grey_1x2.fbx": { polygons: 280, triangles: 560 },
  "blocks/cylinder_grey_1x3.fbx": { polygons: 280, triangles: 560 },
  "blocks/ice.fbx": { polygons: 54, triangles: 108 },
  "blocks/ice_broken.fbx": { polygons: 54, triangles: 108 },
  "blocks/jam_1x1.fbx": { polygons: 154, triangles: 280 },
  "blocks/jam_1x2.fbx": { polygons: 182, triangles: 336 },
  "blocks/jam_1x3.fbx": { polygons: 182, triangles: 336 },
  "blocks/plastic_block_1x1.fbx": { polygons: 150, triangles: 300 },
  "blocks/plastic_block_1x2.fbx": { polygons: 150, triangles: 300 },
  "blocks/plastic_block_1x3.fbx": { polygons: 150, triangles: 300 },
  "blocks/plastic_block_1x4.fbx": { polygons: 150, triangles: 300 },
  "blocks/plastic_block_1x5.fbx": { polygons: 150, triangles: 300 },
  "blocks/plastic_block_2x2.fbx": { polygons: 182, triangles: 364 },
  "blocks/stone_1x1.fbx": { polygons: 54, triangles: 108 },
  "blocks/stone_1x2.fbx": { polygons: 54, triangles: 108 },
  "blocks/stone_1x3.fbx": { polygons: 54, triangles: 108 },
  "blocks/stone_1x4.fbx": { polygons: 54, triangles: 108 },
  "blocks/stone_2x2.fbx": { polygons: 54, triangles: 108 },
  "blocks/tree_block_1x1.fbx": { polygons: 14, triangles: 44 },
  "blocks/tree_block_1x2.fbx": { polygons: 26, triangles: 68 },
  "blocks/tree_block_1x3.fbx": { polygons: 38, triangles: 92 },
  "blocks/tree_block_1x4.fbx": { polygons: 50, triangles: 116 },
  "blocks/tree_block_1x5.fbx": { polygons: 62, triangles: 140 },
  "blocks/watermelon.fbx": { polygons: 60, triangles: 112 },
  "boosters/mine.fbx": { polygons: 106, triangles: 223 },
  "boosters/rocket.fbx": { polygons: 136, triangles: 254 },
  "cannon/cannon.fbx": { polygons: 3014, triangles: 5940 },
  "cannon/cannon_ball.fbx": { polygons: 263, triangles: 524 },
  "tables/table_leg.fbx": { polygons: 335, triangles: 650 },
  "tables/table_rounded_top.fbx": { polygons: 324, triangles: 644 },
  "tables/table_top.fbx": { polygons: 258, triangles: 516 },
};
